import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const TabletIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M18.5 0L4.5 0C3.12 0 2 1.12 2 2.5L2 21.5C2 22.88 3.12 24 4.5 24L18.5 24C19.88 24 21 22.88 21 21.5L21 2.5C21 1.12 19.88 0 18.5 0ZM11.5 23C10.67 23 10 22.33 10 21.5S10.67 20 11.5 20S13 20.67 13 21.5S12.33 23 11.5 23ZM19 19L4 19L4 3L19 3L19 19Z"
      fill="currentColor"
    />
  </svg>
);

TabletIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(TabletIcon);
